import LandingPageLayout from 'components/LandingPageLayout';
import TitleSectionThree from 'components/LandingPageTitleSection/TitleSectionThree';
import React from 'react';
import HeadingSectionV1 from 'components/v1-tailwindcss/HeadingSectionV1';
import UseCasesV1 from 'components/v1-tailwindcss/UseCasesV1';
import LandLordPaysV1 from 'components/v1-tailwindcss/LandLordPaysV1';
// import RentalMontReal from 'components/v1-tailwindcss/RentalMontReal';
import Head from 'next/head';
import RoomSliderOne from 'components/LandingPageCarousels/RoomSliderOne';
import RentalMontReal from 'components/v1-tailwindcss/RentalMontReal';
import FindProperty from 'components/landingPageFindProperty';

const ForLandlords = () => {
  const data = {
    assets: [
      { src: 'static/images/landingPages/ForLandlords/dashboard.png' },
      { src: 'static/images/landingPages/ForLandlords/smartUI.png ' },
      { src: 'static/images/landingPages/ForLandlords/support.png' },
      { src: 'static/images/landingPages/ForLandlords/design.png' },
      { src: 'static/images/landingPages/ForLandlords/accessible.png' },
    ],
  };
  return (
    <>
      <Head>
         
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>For landlords </title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/for-landlords" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Management software for savvy landlords" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="An integrated and holistic
        solution built by Asset Managers
        to help you grow your portfolio."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="google-site-verification" content="w6cEiCyxsJzrruZP6CzL7X8wnD7E8gMMl4q9aU0P59U" />
        <link rel="canonical" href="https://www.soulrooms.com/for-landlords" />
      </Head>
      <LandingPageLayout>
        {/* old component FindProperty */}
        
        <FindProperty
            img={
              <img
                loading="lazy"
                src="/static/images/landingPages/ForLandlords/forlandlords.png"
                width="100%"
                alt="pic"
                className="img img-fluid"
              />
            }
            title={'GO BEYOND THE USUAL.'}
            description={
              <p
                className="lh-base fs-4 text-2xl responsiveText lg:pt-3 md:mt-1 mt-md-1 py-3"
                style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
                An integrated and holistic solution built by Asset Managers to help you grow your portfolio.
              </p>
            }
            href="#JotFormIFrame-212705784372257"
            btnTitle={'Know more'}
          />
        
        

        {/* <RentalMontReal
          btntxt="Know more"
          href="JotFormIFrame-212705784372257"
          mtop="mt-8"
          items="center"
          imgSrc="/static/images/landingPages/ForLandlords/forlandlords.png"
          title="GO BEYOND THE USUAL."
          para2="An integrated and holistic solution built by Asset Managers to help you grow your portfolio. "
        /> */}

        {/* old component UsesCases  */}

        <UseCasesV1 />

        {/* titleSectionCentered missing */}
        <TitleSectionThree
          bg={true}
          title="INTERESTED IN KNOWING MORE?"
          btnTxt="Book a Demo"
          href="https://calendly.com/srdemo/soulrooms-demo"
        />

        {/* old component room RoomSliderOne */}
        <div className="lg:container px-6 lg-px-0 mx-auto pt-12">
          <HeadingSectionV1 title="DESIGNED BY ASSET MANAGERS FOR SAVVY LANDLORDS" />
          <RoomSliderOne imageSource={data.assets} />
        </div>

        {/* <RoomSliderV1 /> */}
        <div className='container mx-auto'>
        <div className='px-4'>
        <HeadingSectionV1 title="MANAGE ALL YOUR PROPERTIES WITH ONE INTUITIVE PLATFORM" mt="mt-12" />
        </div>
        </div>
        

        

        {/* old component LandlordPays */}

        <LandLordPaysV1
          heading1="Multi-Family Residential"
          para="An integrated tool for managing your portfolio, with intuitive UI and a data-driven dashboard."
          image="/static/images/landingPages/ForLandlords/multifamily.png"
          order1="order-1"
          order2="order-2"
          btnhref=""
          btnname="Find out more"
        />
        <LandLordPaysV1
          heading1="Student Housing"
          para="Manage multi-occupant leases, roommate match, profile sharing, move-in, and move-out instructions, and much more."
          image="/static/images/landingPages/ForLandlords/housing.png"
          order1="md:order-2"
          order2="md:order-1"
          btnhref=""
          btnname="Find out more"
        />
        <div className="lg:container px-6  mx-auto">
          <HeadingSectionV1 title="INTERESTED IN LEARNING MORE? DROP US A LINE."  />
          <iframe
              id="JotFormIFrame-212705784372257"
              title="Your Web Design Client Questionnaire"
              onload="window.parent.scrollTo(0,0)"
              allowtransparency="true"
              allowfullscreen="true"
              allow="geolocation; microphone; camera"
              src="https://form.jotform.com/212705784372257?isIframeEmbed=1"
              frameborder="0"
              style={{ minWidth: '100%', height: '640px', border: 'none' }}
              scrolling="no"></iframe>
          {/* RESERVATION FORM  */}
         
        </div>
         <TitleSectionThree
          bg={true}
          title="WANT US TO GIVE YOU A CALLBACK?"
          btnTxt="Submit Request"
          href="#JotFormIFrame-212705784372257"
        />
      </LandingPageLayout>
    </>
  );
};

export default ForLandlords;
